/** Macro #24 — shared Activity presentation helpers. */
import type { ActivityCategory, ActivityEvent } from "../lib/activity-api";

/** Compact relative time, e.g. "just now", "5m", "3h", "2d", else a date. */
export function timeAgo(iso: string | null): string {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const secs = Math.max(0, Math.floor((Date.now() - then) / 1000));
  if (secs < 45) return "just now";
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d`;
  return new Date(iso).toLocaleDateString();
}

export const CATEGORY_LABEL: Record<ActivityCategory, string> = {
  REWARDS: "Rewards",
  LAND: "Land",
  ARTWORK: "Artwork",
  ACCOUNT: "Account",
  SOCIAL: "Social",
};

export const CATEGORY_TINT: Record<ActivityCategory, string> = {
  REWARDS: "text-teal-200 border-teal-300/30 bg-teal-400/10",
  LAND: "text-sky-200 border-sky-300/30 bg-sky-400/10",
  ARTWORK: "text-fuchsia-200 border-fuchsia-300/30 bg-fuchsia-400/10",
  ACCOUNT: "text-amber-200 border-amber-300/30 bg-amber-400/10",
  SOCIAL: "text-violet-200 border-violet-300/30 bg-violet-400/10",
};

/** Navigate to an event's canonical deep-link target (hash route). */
export function gotoDeepLink(ev: ActivityEvent): void {
  const target = ev.deep_link && ev.deep_link.trim().length > 0 ? ev.deep_link : "profile/activity";
  window.location.hash = target;
}
